<template>
  <div>
    <div class="article-block d-column">
      <div class="article-list">
        <div class="module j-flex weight">
          <div v-if="currPrograma != ''" class="fs-xl module-title">
            {{ currPrograma }}
          </div>
          <div v-else class="fs-xl module-title">
            {{ title }}
          </div>
        </div>
        <li
          class="list-each j-flex fs-sm"
          v-for="item in currResData"
          :key="item.id"
          @click="lookDetail(item)"
        >
          <div class="d-flex title">
            <div class="circle"></div>

            <div
              class="a-title overflow"
              v-if="title == '竞赛活动' || title == '竞赛规程'"
            >
              {{ item.name }}
            </div>
            <div class="a-title overflow" v-else>{{ item.title }}</div>
          </div>
          <div class="date" v-if="title == '竞赛活动' || title == '竞赛规程'">
            {{ item.date }}
          </div>
          <div class="date" v-else>{{ item.publishDate | formateDate }}</div>
        </li>

        <div
          v-if="currResData.length == 0"
          style="display: flex; flex-direction: column; align-items: center"
        >
          <img src="../../assets/img/emptybox.svg" />
          <div style="margin-top: 4px">暂无内容</div>
        </div>
      </div>
      <div class="page d-flex fs-md">
        <div class="pageNum">{{ total }}</div>
        条记录 共
        <div class="pageNum">{{ pageNum }}</div>
        页 当前第
        <div class="pageNum">{{ currPage }}</div>
        页
        <button
          class="port-btn"
          :class="{ 'default-btn': currPage == 1 }"
          @click="changeToFirst()"
        >
          首页
        </button>
        <button
          class="changpage-btn"
          :class="{ 'default-btn': currPage == 1 }"
          @click="changeToPrev()"
        >
          上一页
        </button>
        <button
          class="changpage-btn"
          :class="{ 'default-btn': currPage == pageNum }"
          @click="changeToNext()"
        >
          下一页
        </button>
        <button
          class="port-btn"
          :class="{ 'default-btn': currPage == pageNum }"
          @click="changeToLast()"
        >
          末页
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { formateDate } from '@/assets/js/date'
import { getCmsList, getRaceInfo, getRaceRule } from '@/api/api'
export default {
  props: [
    'asideTitle',
    'title',
    'currPrograma',
    'currPath',
    'listIndex',
    'listChildIndex',
    'resData',
  ],
  data() {
    return {
      total: 0,
      pageNum: 0,
      currPage: 1,
      article: {},
      currResData: '',
      limitNum: 12,
      currBlock: 'internationalnews',
    }
  },
  filters: {
    formateDate(time) {
      let date = new Date(time)
      return formateDate(date, 'yyyy-MM-dd')
    },
    getTotalPages(res) {
      return Math.ceil(res.data.length / res.pageSize)
    },
  },
  created() {
    if (this.title == '') {
      this.getResData(this.$route.query.two, this.currPrograma)
    } else {
      this.getResData(this.title, this.currPrograma)
    }
  },
  watch: {
    title: {
      handler(newVal, oldVal) {
        if (newVal == '教学信息') {
          this.getResData(this.title, this.currPrograma)
        }
        if (oldVal != '') {
          this.getResData(this.title, this.currPrograma)
        }
      },
    },
  },
  methods: {
    getResData(currTitle, programa) {
      if (currTitle == '国际新闻' || programa == '国际新闻') {
        this.currBlock = 'internationalnews'
      } else if (currTitle == '国内新闻' || programa == '国内新闻') {
        this.currBlock = 'nationalnews'
      } else if (currTitle == '学校新闻' || programa == '学校新闻') {
        this.currBlock = 'schoolnews'
      } else if (currTitle == '部门新闻' || programa == '部门新闻') {
        this.currBlock = 'departmentnews'
      } else if (currTitle == '学校工会' || programa == '学校工会') {
        this.currBlock = 'schoolunion'
      } else if (currTitle == '部门工会' || programa == '部门工会') {
        this.currBlock = 'departmentunion'
      } else if (currTitle == '新闻报道' || programa == '新闻报道') {
        this.currBlock = 'schoolsportnews'
      } else if (currTitle == '国务院' || programa == '国务院') {
        this.currBlock = 'theStateCouncil'
      } else if (currTitle == '教育部' || programa == '教育部') {
        this.currBlock = 'educationMinistry'
      } else if (currTitle == '教育厅' || programa == '教育厅') {
        this.currBlock = 'educationDepartment'
      } else if (currTitle == '市教育局' || programa == '市教育局') {
        this.currBlock = 'municipalEducationBureau'
      } else if (currTitle == '学校' || programa == '学校') {
        this.currBlock = 'school'
      } else if (currTitle == '部门' || programa == '部门') {
        this.currBlock = 'department'
      } else if (currTitle == '科研信息' || programa == '科研信息') {
        this.currBlock = 'researchInformation'
      } else if (currTitle == '科学研究' || programa == '科学研究') {
        this.currBlock = 'scientificresearch'
      } else if (currTitle == '专家讲座' || programa == '专家讲座') {
        this.currBlock = 'lecture'
      } else if (currTitle == '教授引领' || programa == '教授引领') {
        this.currBlock = 'professorleading'
      } else if (currTitle == '科研成果' || programa == '科研成果') {
        this.currBlock = 'achievements'
      } else if (currTitle == '教学信息' || programa == '教学信息') {
        this.currBlock = 'educationInformation'
        //   } else if (currTitle == '社团公告' || programa == '社团公告') {
        //     this.currBlock = 'communitygg'
      } else if (currTitle == '社团活动' || programa == '社团活动') {
        this.currBlock = 'communityhd'
      } else if (currTitle == '社团纳新' || programa == '社团纳新') {
        this.currBlock = 'communitynx'
      } else if (currTitle == '队伍风采' || programa == '队伍风采') {
        this.currBlock = 'schoolsportnews'
      } else if (currTitle == '赛事新闻' || programa == '赛事新闻') {
        this.currBlock = 'nationalcompetition'
      } else {
        this.currBlock = ''
        this.currResData = this.article
      }
      if (this.currBlock != '') {
        getCmsList(this.currBlock, this.currPage, this.limitNum).then((res) => {
          if (res.data.statusCode == 1) {
            this.currResData = res.data.obj.data
            this.total = res.data.obj.count
            if (res.data.obj.count > 0) {
              this.pageNum = Math.ceil(this.total / this.limitNum)
            }
          }
        })
      } else {
        if (currTitle == '竞赛规程' || programa == '竞赛规程') {
          getRaceRule(this.currPage, this.limitNum).then((res) => {
            if (res.data.statusCode == 1) {
              this.currResData = res.data.obj.data
              this.total = res.data.obj.count
              if (res.data.obj.count > 0) {
                this.pageNum = Math.ceil(this.total / this.limitNum)
              }
            }
          })
        }
        if (currTitle == '竞赛活动' || programa == '竞赛活动') {
          getRaceInfo(this.currPage, this.limitNum).then((res) => {
            if (res.data.statusCode == 1) {
              console.log('22:', res)
              this.currResData = res.data.obj.data
              this.total = res.data.obj.count
              if (res.data.obj.count > 0) {
                this.pageNum = Math.ceil(this.total / this.limitNum)
              }
            }
          })
        }
      }
    },
    lookDetail(item) {
      let routeInfo = this.$router.resolve({
        path: '/article',
        query: {
          one: this.asideTitle,
          two: this.title,
          three: this.currPrograma,
          path: this.currPath,
          keepalive: this.listIndex,
          keepchild: this.listChildIndex,
          articleId: item.uuid,
        },
      })
      this.$store.commit('setBreadThree', this.currPrograma)
      window.open(routeInfo.href, '_blank')
    },
    changeToFirst() {
      this.currPage = 1
      if (this.title == '') {
        this.getResData(this.$route.query.two, this.currPrograma)
      } else {
        this.getResData(this.title, this.currPrograma)
      }
    },
    changeToPrev() {
      if (this.currPage > 1) {
        this.currPage -= 1
        if (this.title == '') {
          this.getResData(this.$route.query.two, this.currPrograma)
        } else {
          this.getResData(this.title, this.currPrograma)
        }
      }
    },
    changeToNext() {
      if (this.currPage < Math.ceil(this.total / this.limitNum)) {
        this.currPage += 1
        if (this.title == '') {
          this.getResData(this.$route.query.two, this.currPrograma)
        } else {
          this.getResData(this.title, this.currPrograma)
        }
      }
    },
    changeToLast() {
      this.currPage = Math.ceil(this.total / this.limitNum)
      if (this.title == '') {
        this.getResData(this.$route.query.two, this.currPrograma)
      } else {
        this.getResData(this.title, this.currPrograma)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/main.scss';
.article-block {
  width: 692px;
  height: 548px;
  background-color: $white;
  padding: 24px 64px;
}
.module {
  //   border-bottom: 1px dashed #000000;
  background: url('../../assets/img/dot.jpg');
  background-repeat: repeat-x;
  background-position: bottom;
  line-height: 34px;
  padding-bottom: 8px;
  color: $titleFont;
}
.more {
  color: $lightFont;
  cursor: pointer;
}
.article-list {
  width: 100%;
  height: 500px;
  //   margin-left: 24px;
}
.circle {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: $mainFont;
  margin-right: 8px;
  margin-left: 8px;
}
.list-each {
  list-style: none;
  color: $mainFont;
  line-height: 36px;
  //   border-bottom: 1px dashed $mainFont;
  background: url('../../assets/img/dot.jpg');
  background-repeat: repeat-x;
  background-position: bottom;
  cursor: pointer;
  &:hover {
    color: $darkGrenn;
    .circle {
      background-color: $darkGrenn;
    }
    .date {
      color: $darkGrenn;
    }
  }
}
.title {
  align-items: center;
  width: calc(100% - 130px);
}
.a-title {
  width: calc(100% - 10px);
}
.module-title {
  font-weight: 600;
}
.date {
  color: $lightFont;
}
.page {
  color: #2f2f2f;
  align-items: center;
}
.pageNum {
  color: #007a4d;
  padding-left: 5px;
  padding-right: 5px;
}
.page {
  button {
    margin-left: 14px;
    border: none;
    font-size: 13px;
    border-radius: 2px;
    padding: 2px 4px;
    color: #fff;
  }
}
.port-btn {
  width: 34px;
  height: 21px;
  background: #66af94;
  cursor: pointer;
}
.changpage-btn {
  width: 47px;
  height: 21px;
  background: #007a4d;
  cursor: pointer;
}
.default-btn {
  background: #d1d1d1 !important;
}
</style>
